var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66053 1.23535C4.82622 1.2731 4.99422 1.30315 5.15683 1.35091C6.17407 1.65214 6.86379 2.29852 7.18669 3.31392C7.36625 3.87786 7.53425 4.44643 7.6876 5.01807C7.73847 5.20759 7.82247 5.25305 8.00973 5.25305C12.9673 5.24765 17.924 5.25074 22.8815 5.24611C23.5134 5.24534 24.076 5.4002 24.5099 5.87631C25.0347 6.45258 25.1464 7.11975 24.9122 7.85858C24.2432 9.96797 23.5828 12.0789 22.9131 14.1883C22.6087 15.1459 21.9806 15.8054 21.0204 16.1081C20.6914 16.2114 20.3307 16.2545 19.9847 16.2553C17.0686 16.2669 14.1517 16.2645 11.2356 16.2607C9.73442 16.2584 8.68866 15.4733 8.26096 14.0311C7.2784 10.7153 6.30045 7.39787 5.32097 4.08125C5.13525 3.4526 4.8663 3.25152 4.20046 3.25152C3.567 3.25152 2.93276 3.22532 2.30084 3.25922C1.68124 3.29158 1.2389 3.08819 1 2.50191C1 2.34551 1 2.18912 1 2.03273C1.13717 1.61362 1.42616 1.35554 1.84462 1.23535C2.78326 1.23535 3.7219 1.23535 4.66053 1.23535Z",
    stroke: "#005555",
    strokeWidth: 1.11671
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5506 18.6475C20.6595 18.6467 21.5689 19.5558 21.562 20.659C21.555 21.7545 20.6526 22.6482 19.5529 22.649C18.444 22.6497 17.5354 21.7414 17.5415 20.639C17.5477 19.5435 18.4509 18.649 19.5506 18.6475Z",
    stroke: "#005555",
    strokeWidth: 1.11671
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.839 20.6535C12.8351 21.7683 11.9396 22.6527 10.8199 22.6488C9.71016 22.6442 8.82932 21.7436 8.83548 20.6203C8.84165 19.5264 9.75254 18.635 10.853 18.6481C11.9604 18.6604 12.8428 19.551 12.839 20.6535Z",
    stroke: "#005555",
    strokeWidth: 1.11671
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2984e528b3ebdc5b4fd0e6abaf57b795.svg";
export { ForwardRef as ReactComponent };